import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPut, doDownload, doDeleteData, doPostFiles } from './utils'

// const API_ROOT = 'http://localhost:9012/api'

const API_PATH = API_ROOT + '/subproject/propersal'

//1.ชื่อโครงการ
export const getSubProjectName = (projectId) => {
  const url = `${API_PATH}/project-name/${projectId}`
  return doGet(url)
}

export const saveSubProjectName = (projectId, request) => {
  const url = `${API_PATH}/project-name/${projectId}`
  return doPost(url, request)
}

//2.ผู้เสนอโครงการ
export const getProjectProponent = (projectId) => {
  const url = `${API_PATH}/project-proponent/${projectId}`
  return doGet(url)
}

export const saveProjectProponent = (projectId, request) => {
  const url = `${API_PATH}/project-proponent/${projectId}`
  return doPost(url, request)
}

//3.ผู้รับผิดชอบโครงการ/ผู้รับทุน
export const getFormProjectResponsiblerAndGrantee = (projectId) => {
  const url = `${API_PATH}/project-responsibler-grantee/${projectId}`
  return doGet(url)
}
//3.1.ผู้รับผิดชอบโครงการ
export const getFormProjectResponsibler = (projectId) => {
  const url = `${API_PATH}/project-responsibler/${projectId}`
  return doGet(url)
}

export const saveFormProjectResponsibler = (projectId, request) => {
  const url = `${API_PATH}/project-responsibler/${projectId}`
  return doPost(url, request)
}
//3.2.ผู้รับทุน
export const getFormProjectGrantee = (projectId) => {
  const url = `${API_PATH}/project-grantee/${projectId}`
  return doGet(url)
}

export const saveFormProjectGrantee = (projectId, request) => {
  const url = `${API_PATH}/project-grantee/${projectId}`
  return doPost(url, request)
}

//4.ผู้ร่วมทำโครงการ
export const getFormProjectCoMaker = (projectId) => {
  const url = `${API_PATH}/project-comaker/${projectId}`
  return doGet(url)
}

export const saveFormProjectCoMaker = (projectId, request) => {
  const url = `${API_PATH}/project-comaker/${projectId}`
  return doPost(url, request)
}

export const delFormProjectCoMakerById = (projectId, id) => {
  const url = `${API_PATH}/project-comaker/${projectId}/${id}`
  return doDeleteData(url)
}

//5.คุณสมบัติพื้นฐานและลักษณะต้องห้ามผู้เสนอโครงการ
export const getFormProjectFeature = (projectId) => {
  const url = `${API_PATH}/project-feature/${projectId}`
  return doGet(url)
}

export const saveFormProjectFeature = (projectId, request) => {
  const url = `${API_PATH}/project-feature/${projectId}`
  return doPost(url, request)
}

//6.ความเป็นมา/หลักการและเหตุผล/ความสำคัญของปัญหา
export const getFormProjectBackground = (projectId) => {
  const url = `${API_PATH}/project-background/${projectId}`
  return doGet(url)
}

export const saveFormProjectBackground = (projectId, request) => {
  const url = `${API_PATH}/project-background/${projectId}`
  return doPost(url, request)
}

//ความสอดคล้องของโครงการ กับเป้าหมายเชิงยุทธศาสาตร์ 10 ปี
export const getSubProjectProjectGoal = (projectId) => {
  const url = `${API_PATH}/project-goal/${projectId}`
  return doGet(url)
}

export const saveSubProjectProjectGoal = (projectId, request) => {
  const url = `${API_PATH}/project-goal/${projectId}`
  return doPost(url, request)
}

//7.วัตถุประสงค์ ผลลัพธ์และตัวชี้วัด
export const getFormProjectObjectiveOutcomeIndicator = (projectId) => {
  const url = `${API_PATH}/project-objective-outcome-indicator/${projectId}`
  return doGet(url)
}

export const saveFormProjectObjectiveOutcomeIndicator = (projectId, request) => {
  const url = `${API_PATH}/project-objective-outcome-indicator/${projectId}`
  return doPost(url, request)
}

//8.  กลุ่มเป้าหมายและพื้นที่ดำเนินการ
export const getFormTargetGroupOperationArea = (projectId) => {
  const url = `${API_PATH}/project-target-group-operation-area/${projectId}`
  return doGet(url)
}
//8.1  กลุ่มเป้าหมาย
export const getFormTargetGroup = (projectId) => {
  const url = `${API_PATH}/project-target-group/${projectId}`
  return doGet(url)
}

export const saveFormTargetGroup = (projectId, request) => {
  const url = `${API_PATH}/project-target-group/${projectId}`
  return doPost(url, request)
}
//8.2 พื้นที่ดำเนินการ
export const getFormOperationArea = (projectId) => {
  const url = `${API_PATH}/project-operation-area/${projectId}`
  return doGet(url)
}

export const saveFormOperationArea = (projectId, request) => {
  const url = `${API_PATH}/project-operation-area/${projectId}`
  return doPost(url, request)
}

//9.ระยะเวลาดำเนินงาน
export const getFormOperatingPeriod = (projectId) => {
  const url = `${API_PATH}/project-operating-period/${projectId}`
  return doGet(url)
}

export const saveFormOperatingPeriod = (projectId, request) => {
  const url = `${API_PATH}/project-operating-period/${projectId}`
  return doPost(url, request)
}

//10.กิจกรรมการดำเนินงาน/แผนการดำเนินงาน
export const getFormActivities = (projectId) => {
  const url = `${API_PATH}/project-activities/${projectId}`
  return doGet(url)
}

export const saveFormActivity = (projectId, request) => {
  const url = `${API_PATH}/project-activity/${projectId}`
  return doPost(url, request)
}

export const deleteFormActivity = (projectId, id) => {
  const url = `${API_PATH}/project-activity/${projectId}/${id}`
  return doDeleteData(url)
}

export const saveFormActivityAdditionalSupport = (projectId, request) => {
  const url = `${API_PATH}/project-activity/additional-support/${projectId}`
  return doPost(url, request)
}
//11.การสนับสนุนทรัพยากรจากหน่วยงานอื่น
export const getFormOtherSupport = (projectId) => {
  const url = `${API_PATH}/project-other-support/${projectId}`
  return doGet(url)
}

export const saveFormOtherSupport = (projectId, request) => {
  const url = `${API_PATH}/project-other-support/${projectId}`
  return doPost(url, request)
}

export const delFormOtherSupportById = (projectId, id) => {
  const url = `${API_PATH}/project-other-support/${projectId}/${id}`
  return doDeleteData(url)
}

//12.จัดการ วิธีรายงานผลลัพธ์ของโครงการ
export const getFormResultsReport = (projectId) => {
  const url = `${API_PATH}/project-results-report/${projectId}`
  return doGet(url)
}

export const saveFormResultsReport = (projectId, request) => {
  const url = `${API_PATH}/project-results-report/${projectId}`
  return doPost(url, request)
}

//13.องค์กรภาคีที่ร่วมดำเนินงาน
export const getFormPartner = (projectId) => {
  const url = `${API_PATH}/project-partner/${projectId}`
  return doGet(url)
}

export const saveFormPartner = (projectId, request) => {
  const url = `${API_PATH}/project-partner/${projectId}`
  return doPost(url, request)
}

export const delFormPartnerById = (projectId, id) => {
  const url = `${API_PATH}/project-partner/${projectId}/${id}`
  return doDeleteData(url)
}

//13.1.ผลที่คาดว่าจะได้รับ
export const getExpectedResult = (projectId) => {
  const url = `${API_PATH}/expected-result/${projectId}`
  return doGet(url)
}

export const saveExpectedResult = (projectId, request) => {
  const url = `${API_PATH}/expected-result/${projectId}`
  return doPost(url, request)
}

//14.เอกสารแนบท้ายโครงการ
export const getFormProjectAttachments = (projectId) => {
  const url = `${API_PATH}/project-attachments/${projectId}`
  return doGet(url)
}

export const saveFormProjectAttachments = (projectId, request) => {
  const url = `${API_PATH}/project-attachments/${projectId}`
  return doPostFiles(url, request)
}

//15.ภาคผนวก
export const getFormProjectAppendix = (projectId) => {
  const url = `${API_PATH}/project-appendix/${projectId}`
  return doGet(url)
}

export const saveFormProjectAppendix = (projectId, request) => {
  const url = `${API_PATH}/project-appendix/${projectId}`
  return doPostFiles(url, request)
}

export const updateFormProjectAppendixName = (projectId, request) => {
  const url = `${API_PATH}/project-appendix/${projectId}/attach/update`
  return doPut(url, request)
}

export const updateFormProjectAppendixSeq = (projectId, fileId, seqNo) => {
  const url = `${API_PATH}/project-appendix/${projectId}/attach/${fileId}/${seqNo}`
  return doPut(url)
}

export const delFormProjectAppendix = (projectId, fileId) => {
  const url = `${API_PATH}/project-appendix/${projectId}/attach/${fileId}`
  return doDeleteData(url)
}
